// components/ui/button.js
import './button.css';

export function Button({ children, ...props }) {
  return (
    <button {...props} className="custom-button">
      {children}
    </button>
  );
}